import { ChevronDown } from "lucide-react";
import { forwardRef, type SelectHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export const Seletor = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  function Seletor({ className, children, ...props }, ref) {
    return (
      <span className={cn("relative block", className)}>
        <select
          ref={ref}
          className="h-10 w-full appearance-none rounded-md border border-neutral-200 bg-white pl-3 pr-9 text-sm text-neutral-900 shadow-xs hover:border-neutral-300"
          {...props}
        >
          {children}
        </select>
        <ChevronDown
          size={16}
          strokeWidth={1.75}
          className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-neutral-400"
        />
      </span>
    );
  },
);

export function Rotulo({
  texto,
  children,
  ajuda,
}: {
  texto: string;
  children: React.ReactNode;
  ajuda?: string;
}) {
  return (
    <label className="block space-y-1.5">
      <span className="block text-sm font-semibold text-neutral-800">{texto}</span>
      {children}
      {ajuda && <span className="block text-xs text-neutral-500">{ajuda}</span>}
    </label>
  );
}
